import { Avatar, Box, Flex, HStack } from "@chakra-ui/react";
import CDS from "design-system";
import { BasicUser } from "features/User/models";

interface SupportCrewMember {
  user: BasicUser;
  roles: string[];
}

interface PeoplePillsProps {
  supportCrew: SupportCrewMember[];
}

function PersonPill({ user }: { user: BasicUser }) {
  const handleClick = () => {
    if (user.slackUrl) window.open(user.slackUrl, "_blank");
  };

  return (
    <HStack
      spacing={2}
      px={3}
      py={1.5}
      borderRadius="full"
      border="1px solid"
      borderColor="gray.200"
      bg="white"
      flexShrink={0}
      cursor={user.slackUrl ? "pointer" : "default"}
      _hover={user.slackUrl ? { borderColor: "gray.300", bg: "gray.50" } : {}}
      onClick={handleClick}
    >
      <Avatar src={user.avatarUrl} name={user.fullName ?? ""} size="2xs" />
      <CDS.Text10 fontWeight="500" color="content.primary" whiteSpace="nowrap">
        {user.givenName || user.firstName}
      </CDS.Text10>
    </HStack>
  );
}

export default function PeoplePills({ supportCrew }: PeoplePillsProps) {
  if (supportCrew.length === 0) return null;

  return (
    <Box overflowX="auto" css={{ "&::-webkit-scrollbar": { display: "none" }, msOverflowStyle: "none", scrollbarWidth: "none" }}>
      <Flex gap={2} pb={1}>
        {supportCrew.map(({ user }) => (
          <PersonPill key={user.id} user={user} />
        ))}
      </Flex>
    </Box>
  );
}
